import React, { useEffect } from 'react';

function DisableWholeService() {
	useEffect(() => {
		const originalOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		return () => {
			document.body.style.overflow = originalOverflow;
		};
	}, []);

	const overlayStyle = {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100vw',
		height: '100vh',
		background: 'rgba(0,0,0,0.6)',
		zIndex: 9999,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		pointerEvents: 'auto',
	};

	const infoBoxStyle = {
		background: '#fff',
		padding: '2rem 3rem',
		borderRadius: '10px',
		boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
		textAlign: 'center',
		fontSize: '1.3rem',
		fontWeight: '500',
	};

	return (
		<div style={overlayStyle} tabIndex={-1}>
			<div style={infoBoxStyle}>
				<h2>Haldor är inte tillgängligt </h2>
				Kommunen/skolan har beslutat att tillfälligt inaktivera Haldor.<br />
				Kontakta kommunen eller skolan vid frågor.
			</div>
		</div>
	);
}

export default DisableWholeService;
